import { IFollowUpFilters } from "us.collection.followup/interfaces";

export const followUpFilters: IFollowUpFilters = {
  searchText: "",
  caseStates: {
    open: true,
    sentence: true,
    nextDueDate: true,
    court: true,
    close: true,
  },
  entityType: "",
  userOwnedClaims: false,
  actionStatus: "all",
  selectedReasons: [-1],
  selectedCaseHandlers: [],
  createdUser: "",
};

export enum MyClaimsEnabled {
  YES = "Yes",
  NO = "No",
}
